const VARIANTS = 2;

export const embedTicket = () => {
	const ticket = document.querySelector('.embed-ticket');
	if (!ticket || ticket.dataset.variant) return;
	ticket.dataset.variant = Math.floor(Math.random() * VARIANTS) + 1;
};
